import {useState, useMemo, useEffect, useCallback} from 'react';
import {CLIENT, getFromLocal, storeLocal, removeLocal} from "helpers/utils.js";
import {fetchMe, handlelogout} from "helpers/userManagement.js";
import {installAuthInterceptor, setOnUnauthorized} from "helpers/authInterceptor.js";

const useAuth = () => {
  const [role, setRole] = useState('');
  const [designation, setDesignation] = useState('');
  const [user, setUser] = useState();

  const logout = () => {
    handlelogout(() => {
      setRole('');
      setUser();
    })
  }

  // Called when the fetch interceptor (authInterceptor.js) detects a dead
  // session mid-app — distinct from logout() above, which also calls the
  // backend /v1/logout endpoint; pointless here since we already know the
  // session is dead.
  const forceLogout = useCallback(() => {
    removeLocal('user');
    setRole('');
    setDesignation('');
    setUser();
  }, []);

  useEffect(() => {
    setOnUnauthorized(forceLogout);
    installAuthInterceptor();
  }, [forceLogout]);

  useMemo(() => {
    async function initUserScope() {
      let currentUser = getFromLocal('user')
      if (!currentUser?.email) {
        const me = await fetchMe()
        currentUser = me?.user
        storeLocal("user", currentUser)
      }
      setUser(currentUser)
      if (currentUser?.scopes) {
        const scope = currentUser.scopes.find((s) => s.client_id === CLIENT)
        if (scope) {
          setRole(scope.role)
          setDesignation(scope.designation || '')
        } else {
          setRole("REGISTER")
        }
      }
    }
    initUserScope();
  }, []);

  return {role, designation, user, setUser, logout};
};

export default useAuth;
